import { render, staticRenderFns } from "./DanhSachQuyenTrongVaiTro.vue?vue&type=template&id=1fa0d53e&"
import script from "./DanhSachQuyenTrongVaiTro.vue?vue&type=script&lang=js&"
export * from "./DanhSachQuyenTrongVaiTro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports